<div class="col-sm-12 flex__box flex__box--row" style="padding: 0">
  <div class="col-sm-5 select-field-box flex__box flex__box--column">
    <div class="header-select-field-box">Available</div>
    <div class="search-input">
      <input type="text" name="filterText" [(ngModel)]="filterText" class="form-control" placeholder="Search" />
      <img
        *ngIf="filterText?.length > 0"
        class="search-cross"
        src="/img/general-icons/closeIconGray.svg"
        (click)="clearFilter()"
      />
    </div>
    <div class="select-field-list">
      <div class="field-group-stroke" *ngFor="let group of sortedFieldGroups">
        <div class="field-group-header flex__box align-items-center justify-content-between" (click)="toggleGroupExpanded(group, $event)">
          <div class="d-flex align-items-center field-group-title">
            <button type="button" class="group-expand-button">
              <img [src]="isGroupExpanded(group) ? '/img/vectorUp.svg' : '/img/vectorDown.svg'" alt="toggle group" />
            </button>
            <span class="field-group-name">{{ group.Name }}</span>
          </div>

          <button
            type="button"
            class="group-select-button"
            [class.group-select-button--selected]="isGroupFullySelected(group)"
            (click)="onGroupSelect(group, $event)"
          >
            <img src="/img/general-icons/plusIcon.svg" alt="select group" />
          </button>
        </div>

        <div class="field-group-children" *ngIf="isGroupExpanded(group)">
          <div
            class="field-stroke field-stroke--child flex__box justify-content-between"
            [class.field-stroke--disabled]="isSelected(field)"
            *ngFor="let field of getGroupVisibleFields(group)"
          >
            <span class="field-name">{{ field.DisplayName }}</span>
            <img src="/img/general-icons/plusIcon.svg" (click)="onSelect(field)" [style.cursor]="isSelected(field) ? 'not-allowed' : 'pointer'" />
          </div>
        </div>
      </div>

      <div
        class="field-stroke flex__box justify-content-between"
        [class.field-stroke--disabled]="isSelected(field)"
        *ngFor="let field of filteredStandaloneFields"
      >
        <span class="field-name">{{ field.DisplayName }}</span>
        <img src="/img/general-icons/plusIcon.svg" (click)="onSelect(field)" [style.cursor]="isSelected(field) ? 'not-allowed' : 'pointer'" />
      </div>
    </div>
  </div>

  <div class="col-sm-7 selected-fields-box flex__box flex__box--column">
    <div class="header-selected-fields-box d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <span>Selected</span>
      </div>
      <span class="required-header" *ngIf="showRequired">Required</span>
      <button
        type="button"
        class="button ND--buttons--second-button unselect-all-button"
        (click)="onUnselectAll()"
        title="Unselect all fields"
      >
        {{ unselectAllLabel }}
      </button>
    </div>
    <div class="select-field-list flex__box flex__box--column">
      <kendo-sortable [kendoSortableBinding]="visibleFields" [animation]="true">
        <ng-template let-selectedField="item">
          <div class="selected-field-stroke flex__box justify-content-between">
            <i class="fa fa-bars flex__box align-items-center" style="width: 30px"></i>
            <span class="selected-field-name">{{ selectedField.DisplayName }}</span>

            <div class="ND--elements--common-checkbox" style="width: 150px" *ngIf="showRequired">
              <input
                type="checkbox"
                [id]="'isRequired_' + selectedField.FieldName"
                name="isRequired"
                [disabled]="isSystemField(selectedField)"
                [(ngModel)]="selectedField.IsRequired"
              />
              <span class="required-stroke" *ngIf="selectedField.IsRequired">
                {{ isSystemField(selectedField) ? 'System' : 'Required' }}
              </span>
            </div>

            <img
              src="/img/general-icons/closeIcon.svg"
              [style.visibility]="!isSystemField(selectedField) ? 'visible' : 'hidden'"
              [title]="defaultFields.includes(selectedField.FieldName) ? 'This is a default field and cannot be deleted.' : ''"
              [ngStyle]="{ cursor: defaultFields.includes(selectedField.FieldName) ? 'not-allowed' : 'pointer' }"
              (click)="onUnselect(selectedField)"
            />
          </div>
        </ng-template>
      </kendo-sortable>
    </div>
  </div>
</div>
